<template>
  <!-- 电话咨询 -->
  <div id="telzx">
    <!-- banner -->
    <div class="telzx_banner_fluid">
      <img src="../../assets/telzx/telzxbanner.png" alt="" />
    </div>

    <section><telhflstj /></section>
	<section style="background-color: #f8f8f8;"><select_lawyer/></section>
    <section class="telfdlay_fluid"><telfdlay /></section>

    <section><televalua /></section>

    <section class="w_fluid"><teladv /></section>

  </div>
</template>

<script>

import telhflstj from "./child/telhflstj"; //合肥推荐律师
import select_lawyer from "./child/select_lawyer"; //合肥推荐律师
import telfdlay from "./child/telfdlay"; //专长周边最新记录
import televalua from "./child/televalua"; //评价咨询
import teladv from "./child/teladv"; //评价咨询

export default {
  name: "telzx",
  components: {

    // 私
	select_lawyer,
    telhflstj,
    telfdlay,
    televalua,
    teladv,
  },
};
</script>

<style lang="scss" scoped>
#telzx {
  background-color: #fff;
  .telzx_banner_fluid {
    max-width: 1920px;
    width: 100%;
    height: 520px;
    overflow: hidden;
    margin: 0 auto;
    img {
      width: 1920px;
    }
  }
  .w_fluid {
    width: 100%;
    background-color: #f8f8f8;
  }
}
</style>
